import { applyMiddleware, compose, createStore } from "redux";
import { combineReducers } from "redux";
import { thunk } from "redux-thunk";
import Reducer from "./Reducer";
const rootReducer = combineReducers({
  Reducer,
});

const middleware = [thunk];
const composeEnhancers = compose(applyMiddleware(...middleware));

const configureStore = () => {
  return createStore(rootReducer, composeEnhancers);
};

const Store = configureStore();

export default Store;
